export default "__VITE_ASSET__C9a5cwQS__"